import PropTypes from 'prop-types';
import React from 'react';
import styles from './style.form.css';

class ResetPasswordField extends React.Component {
  render() {
    const { input, meta, type, placeholder, maxLength } = this.props;
    const { touched, error } = meta;
    return (
      <div>
        <div className={styles['field-wrapper']}>
          <input
            {...input}
            type={type}
            maxLength={maxLength}
            placeholder={placeholder}
            className={`${styles['field-input']} ${styles['input-style']} ${
              touched && error ? styles['input-error'] : ''
            }`}
          />
        </div>
        <small className={`error ${styles['text-error-reset']}`}>
          {touched ? error : ''}
        </small>
      </div>
    );
  }
}

ResetPasswordField.propTypes = {
  icon: PropTypes.string,
};

export default ResetPasswordField;
